<template>
  <hm-content title="">
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      label-width="120px"
      class="demo-ruleForm"
    >
      <el-form-item label="任务名称：" prop="taskName">
        <el-input
          type="text"
          v-model.trim="ruleForm.taskName"
          clearable
          placeholder="请输入任务名称"
          size="small"
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="任务时间：" prop="activityDate">
        <el-date-picker
          v-model="ruleForm.activityDate"
          type="daterange"
          align="right"
          start-placeholder="任务开始时间"
          end-placeholder="任务结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker>
      </el-form-item> -->
      <el-form-item
        label="分配规则："
        prop="distributeRule"
      >
        <el-radio-group
          v-model="ruleForm.distributeRule"
          :disabled="editDisabled"
        >
          <el-radio label="byAvg">
            平均随机分配
          </el-radio>
          <el-radio label="byGuider">
            按导购分配
          </el-radio>
        </el-radio-group>
        <div class="form-item-tip" v-if="ruleForm.distributeRule === 'byGuider'">
            请在分配会员的模板中填写导购的信息,否则导购分配将会失败
        </div>
      </el-form-item>
      <el-form-item label="选择机构：" prop="orgCode" v-if="ruleForm.distributeRule === 'byAvg'">
        <el-cascader
          ref="cascader"
          clearable
          v-model="ruleForm.orgCode"
          :props="props"
          placeholder="请选择机构"
          :show-all-levels="false"
          size="small"
          class="mr10"
          @change="changeOrgCode"
        ></el-cascader>
      </el-form-item>
      <el-form-item
        label="导购筛选："
        v-show="ruleForm.orgCode.length"
        prop="employeeIdList"
        v-if="ruleForm.distributeRule === 'byAvg'"
      >
        <div class="daogou-bder">
          <el-transfer
            class="daogou-transfer"
            v-model="ruleForm.employeeIdList"
            filterable
            filter-placeholder="请输入导购名称"
            :titles="['所有导购', '给下列导购安排任务']"
            :button-texts="['到左边', '到右边']"
            @change="handleChange"
            :data="data"
          >
          </el-transfer>
        </div>
      </el-form-item>
      <el-form-item label="会员基础筛选：" prop="model">
        <el-radio-group v-model="ruleForm.model" size="small" :disabled="editDisabled">
          <el-radio-button label="auto" v-if="ruleForm.distributeRule === 'byAvg'">自动筛选</el-radio-button>
          <el-radio-button label="manual">手动筛选</el-radio-button>
          <el-radio-button label="peoplePackage">选择会员人群</el-radio-button>
        </el-radio-group>
        <div v-if="ruleForm.model === 'auto'">
          <!-- <div>
            <el-radio-group v-model="ruleForm.ruleType">
              <el-radio label="no">有宝宝</el-radio>
              <el-radio label="yes">孕期</el-radio>
            </el-radio-group>
          </div>
          <div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                宝宝性别
              </div>

              <el-select
                size="small"
                v-model="ruleForm.baby"
                filterable
                class="ml10"
                clearable
                placeholder="请选择宝宝性别"
              >
                <el-option label="男" value="boy"></el-option>
                <el-option label="女" value="girl"></el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                宝宝年龄段
              </div>
              <el-select
                size="small"
                v-model="ruleForm.babyAge"
                filterable
                class="ml10"
                clearable
                placeholder="请选择宝宝年龄段"
              >
                <el-option label="1-10" value="1-10"></el-option>
                <el-option label="11-12" value="11-12"></el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                消费能力
              </div>

              <el-select
                size="small"
                v-model="ruleForm.baby"
                filterable
                class="ml10"
                clearable
                placeholder="请选择消费能力"
              >
                <el-option label="男" value="boy"></el-option>
                <el-option label="女" value="girl"></el-option>
              </el-select>
            </div>
            <div class="flex flex-wrap">
              <div style="width:70px;">
                客户活跃度
              </div>
              <el-select
                size="small"
                v-model="ruleForm.baby"
                filterable
                class="ml10"
                clearable
                placeholder="请选择客户活跃度"
              >
                <el-option label="男" value="boy"></el-option>
                <el-option label="女" value="girl"></el-option>
              </el-select>
            </div>
          </div> -->
        </div>
        <div v-else-if="ruleForm.model === 'manual'">
          <div>
            <div class="form-tip">
              注:导入格式需按照用户名、电话、名单来源顺序导入，导入同名文件请刷新后再导入，数据量过大时将会造成页面卡顿!
            </div>
            <div class="flex flex-between">
              <div>
                选择分配的会员
              </div>
              <div>
                <el-button
                  type="primary"
                  @click="output('会员基础')"
                  :loading="isOutputing"
                  size="small"
                  >导出数据</el-button
                >
                <span class="open-file pointer ml10">
                  <input
                    class="pointer"
                    type="file"
                    @change="importf"
                    accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  />
                  <el-button class="pointer" type="primary" size="small" v-if="!editDisabled"
                    >导入数据</el-button
                  >
                </span>
              </div>
            </div>
            <div class="table">
              <el-table
                stripe
                border
                ref="guiderTable"
                :data="guiderTemplateList"
                style="width: 100%"
                size="small"
                max-height="400"
                v-if="ruleForm.distributeRule === 'byGuider'"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="会员姓名"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberPhone"
                  label="会员手机号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="source"
                  label="名单来源"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="guiderPhone"
                  label="分配导购手机号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="guiderName"
                  label="分配导购姓名"
                >
                </el-table-column>
              </el-table>
              <el-table
                stripe
                border
                ref="memberTable"
                :data="memberTemplateList"
                style="width: 100%"
                size="small"
                max-height="400"
                v-else
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="name"
                  label="用户名"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="mobile"
                  label="手机号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="source"
                  label="名单来源"
                >
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="flex flex-between">
            <div>
              <span v-if="ruleForm.distributeRule === 'byAvg'">最多展示10条数据，详情请在列表中查看</span>
              <span v-else-if="ruleForm.distributeRule === 'byGuider'">最多展示10条数据，详情请在列表中查看</span>
            </div>
            <!-- <span class="open-file pointer ml10" v-if="ruleForm.distributeRule === 'byGuider'">
              <input
                class="pointer"
                type="file"
                @change="importf"
                accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
              <el-button class="pointer" type="primary" size="small"
                >导入数据</el-button
              >
              <span class="green" v-if="guiderTemplateList && guiderTemplateList.length">(导入成功)</span>
            </span> -->
          </div>
          <div class="table mt20">
            <!-- <el-table
              stripe
              :data="reportsList"
              style="width: 100%"
              id="table"
              size="small"
              border
              :max-height="400"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="
                  (index) => index + (currentPageReports - 1) * pageSizeReports + 1
                "
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="reportResultName"
                label="自定义名称"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="reportName"
                label="人群包名称"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="resultRowsNum"
                label="人群人数"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="schedulingTime"
                label="执行时间"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="realname"
                label="操作人"
              >
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="操作"
                width="200"
              >
                <template slot-scope="scope">
                  <div class="flex flex-center">
                    <el-button size="small" type="text" @click="save(scope.row)"
                      >下载会员明细</el-button
                    >
                  </div>
                </template>
              </el-table-column>
            </el-table> -->

            <el-table
                stripe
                border
                ref="table"
                :data="guiderTemplateList"
                style="width: 100%"
                size="small"
                max-height="400"
                class="mt20"
                v-if="guiderTemplateList.length"
              >
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberName"
                  label="会员姓名"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="memberPhone"
                  label="会员手机号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="source"
                  label="名单来源"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="guiderPhone"
                  label="分配导购手机号"
                >
                </el-table-column>
                <el-table-column
                  header-align="center"
                  align="center"
                  prop="guiderName"
                  label="分配导购姓名"
                >
                </el-table-column>
              </el-table>
          </div>
        </div>
      </el-form-item>
      <el-form-item
        label="任务时长："
        prop="cycleDays"
        v-if="ruleForm.model === 'auto'"
      >
        <el-input
          type="text"
          @input="filterGt0OrFixed0('cycleDays')"
          v-model.trim="ruleForm.cycleDays"
          clearable
          placeholder="请输入任务时长"
          size="small"
        ></el-input
        >天
        <!-- <el-date-picker
          v-model="ruleForm.activityDate"
          type="daterange"
          align="right"
          start-placeholder="任务开始时间"
          end-placeholder="任务结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
        ></el-date-picker> -->
      </el-form-item>
      <el-form-item
        label="转化成功统计："
        prop="transType"
      >
        <el-radio-group
          v-model="ruleForm.transType"
          :disabled="editDisabled"
        >
          <el-radio label="phone">
            不统计转化
          </el-radio>
          <el-radio label="order">
            用户支付订单
          </el-radio>
        </el-radio-group>
        <div class="form-tip" v-if="ruleForm.transType === 'order'">
            导购联系<el-input
                      size="small"
                      clearable
                      style="width: 80px"
                      class="ml10 mr10 ipt"
                      @input="filterGt0('delayDays')"
                      maxlength="2"
                      v-model.trim="ruleForm.delayDays"
                      :disabled="editDisabled"
                    ></el-input
                    >天内，用户产生线上或线下交易即为转化成功
        </div>
      </el-form-item>
      <el-form-item
        label="任务时段："
        prop="activityDate"
        v-if="ruleForm.model === 'manual' || ruleForm.model === 'peoplePackage'"
      >
        <el-date-picker
          v-model="ruleForm.activityDate"
          type="daterange"
          align="right"
          start-placeholder="任务开始时间"
          end-placeholder="任务结束时间"
          value-format="yyyy-MM-dd"
          size="small"
          class="mr10"
          :disabled="byGuiderDisabled"
        ></el-date-picker>
      </el-form-item>
      <el-form-item
        label="任务产生基于："
        prop="model"
        v-if="ruleForm.model === 'auto'"
      >
        <el-radio-group v-model="ruleForm.ruleType">
          <el-radio label="new_member">新客转化</el-radio>
          <el-radio label="loss_warning">流失预警</el-radio>
          <el-radio label="repurchase_recommendation">复购推荐</el-radio>
          <el-radio label="stage_sale">用户生理轴</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item
        label="生理轴设置："
        prop="preDays"
        v-if="ruleForm.model === 'auto'"
      >
        <!-- <el-checkbox-group v-model="ruleForm.slz" size="small" class="ml10">
          <el-checkbox label="pushMember">孕妇</el-checkbox>
          <el-checkbox label="plusMembers">婴儿</el-checkbox>
        </el-checkbox-group> -->
        <div>
          当前生理轴到期前
          <el-input
            type="text"
            @input="filterGt0OrFixed0('preDays')"
            v-model.trim="ruleForm.preDays"
            clearable
            size="small"
          ></el-input
          >天，发布任务
        </div>
      </el-form-item>
      <el-form-item
        label="会员类型"
        prop="memberSelectType"
        v-if="ruleForm.model === 'auto'"
      >
        <el-select
          size="small"
          placeholder="选择优惠券包"
          v-model="ruleForm.memberSelectType"
          filterable
          class="mr10"
        >
          <!-- <el-option label="全部类型推荐人" value="all"></el-option> -->
          <el-option label="会员卡类型" value="member_card"></el-option>
          <!-- <el-option label="会员群组" value="group"></el-option> -->
        </el-select>
        <el-select
          clearable
          v-if="ruleForm.memberSelectType === 'member_card'"
          class="mr10"
          size="small"
          v-model="ruleForm.typeRelIdList"
          placeholder="请选择卡类型"
          filterable
          multiple
        >
          <el-option
            :label="v.typeName"
            :value="v.cardTypeId"
            :key="i"
            v-for="(v, i) in cardTypeList"
          ></el-option>
        </el-select>
        <el-select
          v-if="ruleForm.memberSelectType === 'group'"
          clearable
          multiple
          filterable
          size="small"
          v-model="ruleForm.groupIds"
          placeholder="请选择会员群组"
        >
          <el-option
            :label="v.groupAppellation"
            :value="v.groupId"
            v-for="(v, i) in memberGroupList"
            :key="i"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div class="flex flex-center">
      <el-button type="primary" size="small" @click="submitForm('ruleForm')"
        >发布</el-button
      >
      <el-button size="small" @click="$router.back(-1)">返回</el-button>
    </div>
  </hm-content>
</template>

<script>
import XLSX from "xlsx";
import axios from "axios";

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {},
  data() {
    const validatorFunc = (rule, val, callback) => {
      if (val === "manual") {
        if(this.ruleForm.distributeRule === 'byGuider')
        {
          if (this.guiderTemplateList.length < 1) {
            return callback(new Error("请导入模板"));
          }
        }else{
          if (this.memberTemplateList.length < 1) {
            return callback(new Error("请导入模板"));
          }
        }
      }

      callback();
    };
    const validatorMemberSelectFunc = (rule, val, callback) => {
      if (val === "member_card") {
        if (this.ruleForm.typeRelIdList.length === 0) {
          return callback(new Error("请选择会员卡类型类型"));
        }
      }
      // if (this.ruleForm.slz.length === 0) {
      //   return callback(new Error("请选择生理轴类型"));
      // }
      callback();
    };
    return {
      memberTemplateList: [],
      guiderTemplateList: [],
      data: [],
      isOutputing: false,
      props: {
        lazy: true,
        checkStrictly: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryOrganizationTree", {
                pageNo: 1,
                pageSize: 999,
                loginType: "store"
              })
              .then(res => {
                res.result.records.forEach(v => {
                  v.leaf = Boolean(!v.isParent);
                  v.value = v.orgCode;
                  v.label = v.departName;
                });
                resolve(res.result.records);
              });
          } else {
            this.$store
              .dispatch("queryOrganizationListByParent", {
                parentId: data.treeStruct,
                loginType: "store"
              })
              .then(res => {
                if (res.code === "0" && res.result) {
                  res.result.forEach(v => {
                    v.leaf = Boolean(!v.isParent);
                    v.value = v.orgCode;
                    v.label = v.departName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      ruleForm: {
        taskName: "",
        cycleDays: "",
        orgCode: "",
        activityDate: [],
        employeeIdList: [],
        model: "manual",
        ruleType: "new_member",
        preDays: "",
        memberSelectType: "member_card",
        typeRelIdList: [],
        distributeRule: "byAvg",
        transType: "phone",
        delayDays: "",
      },
      rules: {
        taskName: {
          required: true,
          message: "请输入任务名称",
          trigger: "change"
        },
        activityDate: [
          {
            required: true,
            message: "请选择任务时间",
            trigger: "change"
          }
        ],
        cycleDays: [
          {
            required: true,
            message: "请输入任务时长",
            trigger: "change"
          },
          {
            required: true,
            pattern: /^[1-9][0-9]*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        orgCode: {
          required: true,
          message: "请选择机构",
          trigger: "change"
        },
        employeeIdList: {
          required: true,
          message: "请选择任务导购",
          trigger: "change"
        },
        model: [
          {
            required: true,
            message: "请选择会员基础",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorFunc,
            trigger: "blur"
          }
        ],
        preDays: [
          {
            required: true,
            pattern: /^[1-9][0-9]*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ],
        memberSelectType: [
          {
            required: true,
            message: "请选择会员基础",
            trigger: "change"
          },
          {
            required: true,
            validator: validatorMemberSelectFunc,
            trigger: "blur"
          }
        ]
      },
      taskId: "",
      memberGroupList: [],
      cardTypeList: [],
      editDisabled: true,
      byGuiderDisabled: false,
      rows:{},
      reportsList: [],
      currentPageReports: 1,
      pageSizeReports: 10,
    };
  },
  computed: {},
  watch: {},
  created() {
    this.queryMemberGroupList();
    this.queryCardTypeList();
    this.queryReportsList();
  },
  mounted() {
    this.taskId = this.$route.query.taskId;
    this.$store.dispatch("detailsGuiderTask", this.$route.query).then(res => {
      const result = res.result || {};
      if (res.code == 0) {
        // result.parentId = [result.parentId];
        for (let key in result) {
          //   setTimeout(() => {
          //     if (this.$refs.cascader) {
          //       this.$refs.cascader.presentText = result.parentName;
          //       if (result.orgType == 1) {
          //         this.$refs.cascader.presentText = "无上级机构";
          //       }
          //     }
          //   }, 0);
          // this.ruleForm.parentId = [result.parentId];
          this.ruleForm[key] = result[key];
        }
        this.ruleForm.orgCode = [result.orgCode];
        if (this.ruleForm.model === "manual") {
          if(this.ruleForm.distributeRule === 'byGuider'){
            this.byGuiderDisabled = true;
            this.guiderTemplateList = result.taskDetailModelList;
            this.guiderTemplateList.forEach(v=>{
              v.memberName = v.name;
              v.memberPhone = v.mobile;
            })
          }else{
            this.byGuiderDisabled = false;
            this.memberTemplateList = result.taskDetailModelList;
          }
          this.ruleForm.activityDate = [
            res.result.startDate,
            res.result.endDate
          ];
        }
        if(this.ruleForm.model === "peoplePackage" || this.ruleForm.model === 'tagGroup'){
          this.guiderTemplateList = result.taskDetailModelList;
          this.guiderTemplateList.forEach(v=>{
            v.memberName = v.name;
            v.memberPhone = v.mobile;
          })
          this.byGuiderDisabled = true;
          this.ruleForm.activityDate = [
            res.result.startDate,
            res.result.endDate
          ];
        }

        setTimeout(() => {
          this.$store
            .dispatch("queryEmployee", {
              pageNo: 1,
              pageSize: 9999,
              loginType: "store",
              workingState: "yes",
              orgCode: result.orgCode
            })
            .then(res => {
              let list = [];
              res.result.records.forEach(v => {
                list.push({
                  label: v.realname,
                  key: v.employeeId,
                  pinyin: v.realname
                });
              });
              this.data = list;
            });
          this.$store
            .dispatch("findGuiderList", {
              taskId: this.taskId
            })
            .then(res => {
              this.ruleForm.employeeIdList = [];
              res.result.map(v => {
                this.ruleForm.employeeIdList.push(v.employeeId);
              });
            });
        }, 0);
      }
    });
  },
  methods: {
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|[^\d]+/g, "");
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, ""); //两个连续的"."仅保留第一个"."
    },
    async queryMemberGroupList() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999
      });

      const { records } = result;
      this.memberGroupList = records;
    },
    async queryCardTypeList() {
      const { result } = await this.$store.dispatch("queryCardTypeList", {
        pageNo: 1,
        pageSize: 99999
      });
      this.cardTypeList = result;
    },
    handleChange(value, direction, movedKeys) {},
    changeOrgCode(val) {
      this.ruleForm.employeeIdList = [];
      if (val.length) {
        this.$store
          .dispatch("queryEmployee", {
            pageNo: 1,
            pageSize: 9999,
            loginType: "store",
            workingState: "yes",
            orgCode: val[val.length - 1]
          })
          .then(res => {
            let list = [];
            res.result.records.forEach(v => {
              list.push({
                label: v.realname,
                key: v.employeeId,
                pinyin: v.realname
              });
            });

            this.data = list;
          });
      } else {
        this.data = [];
      }
    },
    async submitForm(formName) {
      const valid = await this.$refs[formName].validate();
      if (valid) {
        if(this.ruleForm.transType === 'order' && !this.ruleForm.delayDays){
          this.$message({
            message: "请输入导购联系天数！",
            type: "warning"
          });
          return;
        }
        const params = JSON.parse(JSON.stringify(this.ruleForm));
        if(this.ruleForm.distributeRule === 'byGuider'){
          params.guiderTemplateList = this.guiderTemplateList;
          params.memberTemplateList = [];
        }else{
          params.memberTemplateList = this.memberTemplateList;
          params.guiderTemplateList = [];
        }
        if (params.model === "manual") {
          params.startDate = params.activityDate[0];
          params.endDate = params.activityDate[1];
          params.memberSelectType = "";
          params.ruleType = "";
        }
        params.orgCode = params.orgCode[params.orgCode.length - 1];

        this.$store.dispatch("editGuiderTask", params).then(res => {
          if (res.code === "0") {
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.$router.back(-1);
          }
        });
      } else {
        return false;
      }
    },
    importf(e) {
      const obj = e.target;
      this.inputData = [];
      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      this.fileName = f.name;
      let reader = new FileReader();
      reader.onload = e => {
        let data = e.target.result;

        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          if(this.ruleForm.distributeRule === 'byGuider' && this.ruleForm.model === 'peoplePackage'){
            wb = XLSX.read(data, { type: 'binary', codepage: 936 })
          }else{
            wb = XLSX.read(data, {
              type: "binary"
            });
          }
        }

        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName]);
          if (roa.length) {
            result = roa;
          }
        });
        let arr = [];

        result.map(v => {
          let obj = {};
          if(this.ruleForm.distributeRule === 'byGuider'){
            obj.source = v.名单来源;
            obj.memberPhone = v.会员手机号;
            obj.memberName = v.会员姓名;
            obj.guiderPhone = v.分配导购手机号;
            obj.guiderName = v.分配导购姓名;
          }else{
            obj.source = v.名单来源;
            obj.mobile = v.手机号;
            obj.name = v.用户名;
          }

          arr.push(obj);

          // formatResult.push({});
          // this.memberTemplateList.map((o, index) => {
          //   formatResult[i][this.memberTemplateList[index]] = v[index];
          // });
        });
        if(this.ruleForm.distributeRule === 'byGuider'){
          this.guiderTemplateList = [...arr];
        }else{
          this.memberTemplateList = [...arr];
        }
        // formatResult = arrayUnique2(formatResult, this.filterText);
        // this.$emit("importSuccess", formatResult);
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    // 导出excel
    output(title) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        let list;
        let tHeader;
        if(this.ruleForm.distributeRule === 'byGuider'){
          list = this.guiderTemplateList;
          tHeader = this.$refs.guiderTable.columns
          .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
          .filter(o => o);
        }else{
          list = this.memberTemplateList;
          tHeader = this.$refs.memberTable.columns
          .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
          .filter(o => o);
        }
        let filterVal = [];
        if (list.length > 0) {
          if(this.ruleForm.distributeRule === 'byGuider'){
            filterVal = this.$refs.guiderTable.$children
            .map(o => o._props.prop)
            .filter(o => o);
          }else{
            filterVal = this.$refs.memberTable.$children
              .map(o => o._props.prop)
              .filter(o => o);
          }
        }
        const data = this.formatJson(filterVal, list);
        exportJsonToExcel(tHeader, data, title + new Date().toLocaleString());
        this.isOutputing = false;
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    // 过滤大于0
    filterGt0(prop) {
      if (this.ruleForm[prop].length === 1) {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/[^0-9]/g, "");
      } else {
        this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)|\D/g, "");
      }
    },
    async queryReportsList() {
      let params = {
        showZeroRecord: "no",
      };
      const { result } = await this.$store.dispatch(
        "queryPeoplePackageDetailResult",
        params
      );
      this.reportsList = result;
    },
    save(row) {
      this.rows = row;
      axios({
        method: "post",
        url:
          this.$serverAdress +
          `/sys/common/download?filePath=${row.responseResultPath}`,
        responseType: "arraybuffer",
      }).then((res) => {
        this.download(res.data);
      });
    },
    download(data) {
      if (!data) {
        return;
      }
      let blob = new Blob([data], { type: "application/octet-stream" });
      let url = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", this.rows.fileName);
      document.body.appendChild(link);
      link.click();
      window.URL.revokeObjectURL(url); //释放掉blob对象
    },
    handleCurrentChange(val) {
      this.rows = val;
      console.log("this.rows:",this.rows);
    },
  }
};
</script>
<style lang="scss">
.daogou-bder {
  .el-transfer-panel {
    width: 250px;
  }
}
</style>
<style lang="scss" scoped>
.daogou-bder {
  width: 700px;
  padding: 30px 10px;
  border: 1px solid #dddddd;
  text-align: center;
  .daogou-transfer {
    text-align: left;
    display: inline-block;
  }
}
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
</style>
